<div class="product-detail-overlay-container" [hidden]="hideOverlay()" #productOverlay>
    @if (loadingProduct()) {
    <webstore-product-detail-overlay-shimmer></webstore-product-detail-overlay-shimmer>
    }
    <button class="close-btn" (click)="closeProductDetail()">
        <img [src]="IMAGE_URLS.closeIconDark" alt="close" />
    </button>

    @if (!loadingProduct() && product()) {
    <div class="pdp-layout-container">
        <section class="controller-panel" [class.variation-disabled]="variantLoading()">
            <div class="product-img-viewer" [class.overlay-masking]="overlayMasking()">
                <webstore-image-viewer [imagesList]="productImages()"></webstore-image-viewer>
            </div>

            <div class="about-this-product">
                <ul [class.overlay-masking]="overlayMasking()">
                    <!-- Deal Countdown -->
                    @if (remainingTime(); as remainingTime) {
                    <li>
                        @if (
                        remainingTime?.remainingTime &&
                        remainingTime.remainingTime > 1000 &&
                        storeConfiguration?.is_deal_active
                        ) {
                        <p class="countdown-info">
                            {{ productDealCountDown()?.badge_message }}
                            @if (remainingTime.daysToToday) {
                            <strong>{{ remainingTime.daysToToday }}</strong>
                            }
                            {{ remainingTime.daysToToday > 0 ? 'd :' : '' }}
                            @if (remainingTime.hoursToToday) {
                            <strong>{{ remainingTime.hoursToToday }}</strong>
                            }
                            {{ remainingTime.hoursToToday > 0 ? 'h :' : '' }} {{ remainingTime.minutesToToday }}m :
                            {{ remainingTime.secondsToToday }}s
                        </p>
                        }
                    </li>
                    }

                    <li>
                        <h1 class="det-text-product-name">
                            {{ product()?.display_name || product()?.name }}
                        </h1>

                        @if (product()?.brand?.name) {
                        <p class="det-text-brand">
                            By
                            <span class="det-text-brand-name" [routerLink]="['/search']" [queryParams]="{
                      brand_id: product()?.brand?.id,
                      brand_name: product()?.brand?.name,
                      utm_source: 'home',
                      utm_medium: product()?.brand?.name,
                    }" (click)="closeProductDetail()">
                                {{ product()?.brand?.name }}</span>
                        </p>
                        }
                    </li>
                    <li>
                        <div class="product-attribute">
                            <span class="det-text-attribute-heading">SKU:</span>
                            <span class="det-text-attribute-content"> {{ product()?.sku }}</span>
                        </div>
                    </li>
                    <li>
                        <p class="pricing-info">
                            @if (sellingPrice() < actualPrice()) { <span class="det-text-current-price">{{ sellingPrice() | indianCurrency }}</span>

                                <!-- <span class="det-text-actual-price">₹69,999</span> -->
                                @if (actualPrice() | percentageDiscount: sellingPrice(); as percentageDiscount) {
                                <span class="det-text-discount">{{ percentageDiscount }}</span>
                                }
                                } @else {
                                <span class="det-text-current-price">{{ sellingPrice() | indianCurrency }}</span>
                                }
                        </p>
                        @if (sellingPrice() < actualPrice() && product()?.mrp) { <p class="det-text-mrp-price">
                            MRP:
                            <span class="det-text-mrp-title" [ngClass]="{
                      'strike-through': sellingPrice() < actualPrice(),
                    }">
                                {{ product()!.mrp | indianCurrency }}</span>
                            </p>
                            }
                            <p class="tax-terms">Inclusive of all taxes</p>
                    </li>
                    @if (hasVariant()) {
                    <li>
                        <webstore-product-variant [attributeSelectionsInput]="currentAttributeSelections" [productInput]="product()!" [isLoadingInput]="variantLoading()" (productUrl$)="setProductUrlPath($event)"></webstore-product-variant>
                    </li>
                    }
                    <li>
                        <base-product-available-offers class="selector-product-available-offer" [availableOffersInput]="availableOffers()"></base-product-available-offers>
                    </li>
                    <li class="selector-razorpay-affordability-widget">
                        <!-- Razorpay widgets -->
                        <webstore-razorpay-affordability-widget [sellingPriceInput]="sellingPrice()"></webstore-razorpay-affordability-widget>
                    </li>
                    @if (product()?.in_stock && product()?.weight && showEstimatedDelivery) {
                    <li class="delivery-etd-status">
                        <webstore-delivery-etd-status [user]="user()" [productIdInput]="product()?.id!" [productUrlPath]="product()?.url_path!"></webstore-delivery-etd-status>
                    </li>
                    }
                </ul>

                <div class="product-actions">
                    <div class="inner-container" [class.overlay-masking]="overlayMasking()">
                        @if (isCartItem()) {
                        <!-- Quantity Controller for existing cart item -->
                        <div class="qty-controller-comp">
                            <div class="editable det-default-qty-action det-default-qty-action-left" (click)="
                      decreaseQuantity({
                        cartItemId: cartItem()?.id ?? '',
                        quantity: (cartItem()?.quantity ?? 0) - 1,
                      })
                    ">
                                -
                            </div>
                            <span class="editable det-text-qty-input" (click)="navToCart()">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="15">
                                    <path fill="#000000" d="M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" />
                                </svg>
                                {{ cartItem()?.quantity ?? 0 }}
                            </span>
                            <div class="det-default-qty-action det-default-qty-action-right" (click)="
                      increaseQuantity({
                        cartItemId: cartItem()?.id ?? '',
                        quantity: (cartItem()?.quantity ?? 0) + 1,
                      })
                    ">
                                +
                            </div>
                        </div>
                        }

                        <!-- Add to Cart button when item is not in cart -->
                        @if (!isCartItem()) {
                        @if (product()?.in_stock || product()?.is_allow_back_orders) {
                        <button class="det-default-add-to-cart-btn" (click)="
                      addToCart({
                        product: product()!,
                        bid_price: bidPrice(),
                        productDetailOverlay: true,
                        stayOnCurrentPage: true,
                      })
                    " [disabled]="!product()" aria-label="Add to cart">
                            <span class="det-text-add-to-cart">
                                @if (product()?.in_stock) {
                                Add to Cart
                                } @else {
                                Pre Order
                                }
                            </span>
                        </button>
                        } @else {
                        <button class="det-default-coming-soon" aria-label="coming soon">
                            <span class="det-text-coming-soon">Coming Soon</span>
                        </button>
                        }
                        }
                        @if (showProductBidding() && product()?.bidding?.is_bidding_active && product()?.in_stock) {
                        <div class="det-default-detailed-view-btn" (click)="openBiddingOverlay()">
                            <span class="det-text-detailed-view">Place Bid</span>
                        </div>
                        }

                        <div class="det-default-detailed-view-btn" (click)="navigateToProductDetailPage('/products/' + product()?.url_path)">
                            <span class="det-text-detailed-view"> Detailed View </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    }
</div>